import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { LANGUAGES, getBrowserLanguage } from '../config/languageConfig';
import '../styles/LanguageSelector.css';

export function LanguageSelector() {
  const { language, setLanguage, isUsingBrowserDefault } = useLanguage();

  const handleLanguageChange = async (e) => {
    const newLanguage = e.target.value;
    try {
      if (newLanguage === 'browser') {
        // Clear storage and use browser default
        localStorage.removeItem('userLanguage');
        const browserLang = getBrowserLanguage();
        await setLanguage(browserLang, true); // true indicates using browser default
      } else {
        // Set specific language
        localStorage.setItem('userLanguage', newLanguage);
        await setLanguage(newLanguage, false);
      }
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  return (
    <select
      value={isUsingBrowserDefault ? 'browser' : language}
      onChange={handleLanguageChange}
      className="language-selector"
      aria-label="Select language"
    >
      <option value="browser">🌐 Browser Default</option>
      {Object.entries(LANGUAGES).map(([code, { nativeName }]) => (
        <option key={code} value={code}>
          {nativeName}
        </option>
      ))}
    </select>
  );
} 